import { Mail, Phone, Briefcase, UserCircle, Linkedin } from "lucide-react";
import { Candidate } from "@/types/candidate";
import { SkillsList } from "@/components/candidates/SkillsList";
import { useTranslation } from "react-i18next";

interface ContactInformationProps {
  candidate: Candidate;
}

export const ContactInformation = ({ candidate }: ContactInformationProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <h3 className="text-lg font-semibold mb-3">{t("candidates.profile.contactInfo")}</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="flex items-center gap-3">
          <Mail className="h-5 w-5 text-gray-400" />
          <div>
            <p className="text-sm text-gray-500">{t("candidates.profile.email")}</p>
            <a
              href={`mailto:${candidate.email}`}
              className="text-blue-600 hover:underline"
            >
              {candidate.email}
            </a>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <Phone className="h-5 w-5 text-gray-400" />
          <div>
            <p className="text-sm text-gray-500">{t("candidates.profile.phone")}</p>
            {candidate.phone ? (
              <a
                href={`tel:${candidate.phone}`}
                className="text-blue-600 hover:underline"
              >
                {candidate.phone}
              </a>
            ) : (
              <span className="text-gray-500">{t("candidates.profile.notProvided")}</span>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <Linkedin className="h-5 w-5 text-gray-400" />
          <div>
            <p className="text-sm text-gray-500">{t("candidates.profile.linkedin")}</p>
            {candidate.linkedin ? (
              <a
                href={candidate.linkedin.startsWith('http') ? candidate.linkedin : `https://${candidate.linkedin}`}
                className="text-blue-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("candidates.profile.viewProfile")}
              </a>
            ) : (
              <span className="text-gray-500">{t("candidates.profile.notProvided")}</span>
            )}
          </div>
        </div>
        
        {candidate.function && (
          <div className="flex items-center gap-3">
            <Briefcase className="h-5 w-5 text-gray-400" />
            <div>
              <p className="text-sm text-gray-500">Position</p>
              <p>{candidate.function}</p>
            </div>
          </div>
        )}
        
        {candidate.manager && (
          <div className="flex items-center gap-3">
            <UserCircle className="h-5 w-5 text-gray-400" />
            <div>
              <p className="text-sm text-gray-500">Manager</p>
              <p>{candidate.manager}</p>
            </div>
          </div>
        )}
      </div>
      
      {/* Skills section added below contact information */}
      <div className="mt-6">
        <SkillsList skills={candidate.skills} />
      </div>
    </div>
  );
};
